import {
    BaseTransitionModel, BaseTransitionProperty,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { IAnimationSetting, ICoverTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import {
    getCoverConfig,
    getPullConfig,
} from '@src/slide/domain/ui-model/element-modeles/transition/config';
import { EightDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/eight-direction';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

export class CoverTransitionModel extends BaseTransitionModel<ICoverTransition> implements ICoverTransition {
    public type = TransitionType.COVER;
    public direction: EightDirection;

    public getAnimationSetting(isSwitchForward?): IAnimationSetting[] {
        const direction = this.direction.getDirectionType(isSwitchForward);
        if (isSwitchForward) {
            // 向前翻页表现为 揭开 动画
            return getPullConfig(direction);
        }
        return getCoverConfig(direction);
    }
}

